export class NoopUsageManager {
    disable() {
        // Noop
    }
    start() {
        return {
            sample: () => ({ cpuTime: 0, wallTime: 0 }),
        };
    }
    stop(measurement) {
        return measurement.sample();
    }
    pauseAsync(cb) {
        return cb();
    }
    sample() {
        return undefined;
    }
}
//# sourceMappingURL=noopUsageManager.js.map